export default [
  {
    id: 1,
    slug: 'bmc',
    title: 'BMC',
    src: '/img/relations/employers/bmc.png',
    url: 'https://www.bmc.nl'
  },
  {
    id: 2,
    slug: 'rhdv',
    title: 'Royal HaskoningDHV',
    src: '/img/relations/employers/rhdhv.png',
    url: 'https://www.royalhaskoningdhv.nl'
  },
  {
    id: 3,
    slug: 'philips',
    title: 'Philips',
    src: '/img/relations/employers/philips.png',
    url: 'https://www.philips.nl',
  },
  {
    id: 4,
    slug: 'honeywell',
    title: 'Honeywell',
    src: '/img/relations/employers/honeywell.png',
    url: 'https://www.honeywell.nl'
  }
]
